import { render, staticRenderFns } from "./WebshopView.vue?vue&type=template&id=7e0161fc"
import script from "./WebshopView.vue?vue&type=script&lang=ts"
export * from "./WebshopView.vue?vue&type=script&lang=ts"
import style0 from "./WebshopView.vue?vue&type=style&index=0&id=7e0161fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports